module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product26-278760d3558f7736b5d3873df03b4a29.jpg";